// apps/admin/src/features/customers/components/CreateCustomerPage.tsx
import { CustomerDataProvider } from '../context/CustomersContext';
import CreateCustomer from './CreateCustomer';


export default function CreateCustomerPage() {
  return (
    <CustomerDataProvider>
      <CreateCustomer />
    </CustomerDataProvider>
  );
}
